import Button from '@klv/atoms/button';
import BlogCard from '@klv/molecules/blog-card';
import { Wrapper } from '@klv/utils/wrapper';

import { generateClassName } from '@klv/shared/utils/functions';
import { getBackgroundType } from '@klv/utils/wrapper/functions';

import * as styles from './styles/resourceCards.module.scss';

import type { IResourceCards } from './types';

export const ResourceCards = ({
  backgroundColor,
  button,
  category,
  className,
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  displayGrayLine,
  headline,
  fadeIn,
  resources,
  postSource,
  subhead,
}: IResourceCards) => (
  <Wrapper
    backgroundColor={backgroundColor}
    customPadding={{ customPaddingTop: 'xs', customPaddingBottom: 'xs' }}
    fadeIn={fadeIn ? .25 : 0}
    inlinePadding={true}
    contained={true}
  >
    <Wrapper
      className={generateClassName([className, displayGrayLine ? styles.grayLine : '', getBackgroundType(backgroundColor)])}
      backgroundColor="transparent"
      customPadding={customPadding}
      grid={true}
    >
      <div className={styles.resourceCardsHeader}>
        <div className={styles.resourceCardsHeaderText}>
          <h2 className={generateClassName(['h3 semibold', styles.header])}>{headline}</h2>
          <p className={generateClassName(['p2'])}>{subhead}</p>
        </div>
        {(['category', 'latest'].includes(postSource) && category?.link) && (
          <div className={styles.resourceCardsHeaderButton}>
            <Button 
              className={styles.button}
              buttonColor={getBackgroundType(backgroundColor) === 'dark' ? 'light' : 'dark'}
              variant="tertiary"
              url={category.link}
              {...button}
            />
          </div>
        )}
      </div>
      <div className={generateClassName(['grid', styles.resourceCards])}>
        {resources?.map(({ featured, uri, date, excerpt, title }) => {
          const image = featured?.featuredPostImage;
          return (
          <BlogCard 
            className={styles.card}
            title={title}
            backgroundColor={getBackgroundType(backgroundColor)}
            categoryLink={category?.link}
            categoryName={category?.name}
            featuredImage={image}
            date={date}
            uri={uri}
            excerpt={excerpt}
          />);
        })}
      </div>
    </Wrapper>
  </Wrapper>
);
